import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { CreditCard, Bitcoin } from "lucide-react";

export default function PaymentMethodDialog({ domain, open, onOpenChange, onCard, onCrypto }) {
  if (!domain) return null;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="payment-method-dialog" className="bg-surface border border-gold/25 text-ink max-w-md p-0 gap-0 rounded-2xl overflow-hidden">
        <div className="p-8">
          <DialogHeader className="text-left space-y-2 mb-7">
            <div className="overline">Acquire {domain.name}</div>
            <DialogTitle className="font-serif text-4xl tracking-tight text-ink">Choose payment</DialogTitle>
            <DialogDescription className="font-mono text-xs text-gold">{domain.price}</DialogDescription>
          </DialogHeader>
          <div className="space-y-3">
            <button
              onClick={() => onCard(domain)}
              data-testid="pay-card"
              className="w-full flex items-center gap-4 border border-white/10 rounded-xl p-5 hover:border-gold hover:bg-gold/5 transition-colors text-left"
            >
              <span className="w-11 h-11 rounded-full bg-gold/10 text-gold flex items-center justify-center"><CreditCard size={18} /></span>
              <span>
                <span className="block text-ink font-semibold">Pay with card</span>
                <span className="block text-ink-dim text-xs">Instant checkout via Stripe</span>
              </span>
            </button>
            <button
              onClick={() => onCrypto(domain)}
              data-testid="pay-crypto"
              className="w-full flex items-center gap-4 border border-white/10 rounded-xl p-5 hover:border-gold hover:bg-gold/5 transition-colors text-left"
            >
              <span className="w-11 h-11 rounded-full bg-gold/10 text-gold flex items-center justify-center"><Bitcoin size={18} /></span>
              <span>
                <span className="block text-ink font-semibold">Pay with crypto</span>
                <span className="block text-ink-dim text-xs">BTC, ETH, USDT & more via NOWPayments</span>
              </span>
            </button>
          </div>
          <p className="mt-5 text-xs text-ink-dim">The domain is reserved on confirmed payment.</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
